import Route from '@ember/routing/route';
import { set } from '@ember/object';

export default class CheckoutRoute extends Route {
  setupController(controller /*, model*/) {
    const application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    set(controller, 'step', 1);
    set(controller, 'paymentAPI', null);
    set(controller, 'termAccepted', false);
    set(controller, 'paymentZero', false);
    // Clear per-checkout residuals so a repeat checkout in the same session does
    // not inherit the previous promo code / booking notes (maint 5.6 leak fix).
    set(controller, 'voucherCode', null);
    set(controller, 'showPromoCode', null);
    set(controller, 'notePrenotazione', null);
    set(controller, 'riepilogo', null);
    set(controller, 'checkTerms', false);
    set(controller, '_wrapContact', null);

    if (Array.isArray(application.gdprField?.organization_term_options?.data)) {
      application.gdprField.organization_term_options.data.forEach((i) => set(i, 'active', false));
    }
  }
}
